export default "__VITE_ASSET__C2r0OHdZ__"